import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { useRef, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Link, useNavigate } from 'react-router-dom';
import NavBar from './NavBar';
import { Grid, Menu, MenuItem, Paper, Skeleton, styled } from '@mui/material';
import { Zoom } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import { removeFromLocalStorage } from '../../../Helper/helper';

const Item = styled(Paper)(({ theme }) => ({
    height: '100%',
    backgroundColor: "#f2f1f1",
    boxShadow: 'none'
}));

const navButtonSx = {
    color: 'white',
    fontSize: 16,
    fontWeight: 500,
    borderRadius: 999,
    padding: '6px 16px',
    position: 'relative',
    transition: 'background 0.2s ease, color 0.2s ease, transform 0.2s ease',
    '&:hover': {
        color: '#fff',
        background: 'rgba(255, 255, 255, 0.14)',
        transform: 'translateY(-1px)',
    },
};

function TabNavigation({ categories, premiumAds, premiumAdsLoading }) {
    const navigate = useNavigate();
    const menuRef = useRef(null);

    const [drawerMenu, setDrawerMenu] = useState(false);

    // News
    const [newsMenu, setNewsMenu] = useState(null);
    const newsOpen = Boolean(newsMenu);
    const handleNewsClick = (event) => {
        setNewsMenu(event.currentTarget);
    };

    // Matrimony
    const [matrimonyMenu, setMatrimonyMenu] = useState(null);
    const matrimonyOpen = Boolean(matrimonyMenu);
    const handleMatrimonyClick = (event) => {
        setMatrimonyMenu(event.currentTarget);
    };

    // Products
    const [productsMenu, setProductsMenu] = useState(null);
    const productsOpen = Boolean(productsMenu);
    const handleProductsClick = (event) => {
        setProductsMenu(event.currentTarget);
    };

    // Topics
    const [topicsMenu, setTopicsMenu] = useState(null);
    const topicsOpen = Boolean(topicsMenu);
    const handleTopicsClick = (event) => {
        setTopicsMenu(event.currentTarget);
    };

    // About
    const handleAboutClick = (event) => {
        navigate(`/about-us`);
    };

    const handleOpenNavMenu = (event) => {
        setDrawerMenu(true);
    };

    const navigateNewsListOfCategory = (news) => {
        if (news?.categoryName === 'Matrimony') {
            removeFromLocalStorage(window.location.pathname);
            navigate(`/user/matrimony`);
        } else if (news?.categoryName === 'Obituary') {
            removeFromLocalStorage(`/user/obituary`);
            navigate(`/user/obituary`);
        } else {
            removeFromLocalStorage(`/user/news/category/list`);
            navigate(`/user/news/category/list`, {
                state: {
                    category: news?.categoryName,
                    type: news?.type,
                }
            });
        }
    }

    const navigateMatrimonyWithType = (type) => {
        removeFromLocalStorage(window.location.pathname);
        navigate(`/user/matrimony`, {
            state: {
                matrimonyType: type,
            }
        })
    }

    return (
        <Box ref={menuRef}>
            <Grid container spacing={2} style={{ marginTop: '2px', marginBottom: '10px' }}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Item>
                        <img alt="complex" src={"/UserSideImages/logo1.jpg"} style={{ width: '100%', height: '80px' }} />
                    </Item>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} style={{ paddingTop: '0px' }}>
                    <Item>
                        {premiumAdsLoading ? (
                            <Skeleton variant="rounded" animation="wave" style={{ width: "100%", height: "100px" }} />
                        ) : (
                            <div className="slide-container">
                                {premiumAds.length > 1 ? (
                                    <Zoom scale={0.4} defaultIndex={0}>
                                        {premiumAds.map((each, index) => (
                                            <Link to={each?.link || "#"} key={index}>
                                                <div style={{ width: "100%", aspectRatio: "7.5 / 1", borderRadius: 5, background: "#f4f5fa", overflow: "hidden" }}>
                                                    <img
                                                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                                        loading="lazy"
                                                        src={each?.image?.url || "/path-to-default-image.jpg"}
                                                        alt={`Premium ${index + 1}`}
                                                    />
                                                </div>
                                            </Link>
                                        ))}
                                    </Zoom>
                                ) : premiumAds.length === 1 ? (
                                    <Link to={premiumAds[0]?.link || "#"}>
                                        <div style={{ width: "100%", aspectRatio: "7.5 / 1", borderRadius: 5, background: "#f4f5fa", overflow: "hidden" }}>
                                            <img
                                                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                                loading="lazy"
                                                src={premiumAds[0]?.image?.url || "/path-to-default-image.jpg"}
                                                alt="Premium"
                                            />
                                        </div>
                                    </Link>
                                ) : (
                                    <div style={{ width: "100%", aspectRatio: "7.5 / 1", borderRadius: 5, background: "#f4f5fa", overflow: "hidden" }}>
                                        <img
                                            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                            loading="lazy"
                                            src="/UserSideImages/default_Add.jpeg"
                                            alt="Default Premium Ad"
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                    </Item>
                </Grid>
            </Grid>
            <Box>
                <AppBar
                    position="sticky"
                    sx={{
                        top: 0,
                        background: 'rgba(28, 35, 101, 0.75)',
                        backdropFilter: 'blur(14px) saturate(160%)',
                        WebkitBackdropFilter: 'blur(14px) saturate(160%)',
                        borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                    }}
                >
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>

                            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenNavMenu}
                                    color="inherit"
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Box>
                            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            </Box>
                            <Box sx={{ flexGrow: 0 }}>
                                <Box sx={{ flexGrow: 1, gap: 2, display: { xs: 'none', md: 'flex' } }}>
                                    <div>
                                        <Button
                                            sx={navButtonSx}
                                            onClick={() => { removeFromLocalStorage(`/`); navigate(`/`); setNewsMenu(false); setProductsMenu(false); setTopicsMenu(false); }}
                                        >Home
                                        </Button>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <Button
                                            sx={navButtonSx}
                                            endIcon={newsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            id="news-and-views"
                                            aria-controls={newsOpen ? 'news-and-views' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={newsOpen ? 'true' : undefined}
                                            onClick={handleNewsClick}
                                        >News & Views
                                        </Button>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <Button
                                            endIcon={matrimonyOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            sx={navButtonSx}
                                            id="matrimony"
                                            aria-controls={matrimonyOpen ? 'matrimony' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={matrimonyOpen ? 'true' : undefined}
                                            onClick={handleMatrimonyClick}
                                        >Matrimony
                                        </Button>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div>
                                            <Button
                                                sx={navButtonSx}
                                                endIcon={productsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                id="classifieds"
                                                aria-controls={productsOpen ? 'classifieds' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={productsOpen ? 'true' : undefined}
                                                onClick={handleProductsClick}
                                            >Classifieds
                                            </Button>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div>
                                            <Button
                                                sx={navButtonSx}
                                                endIcon={topicsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                id="topics"
                                                aria-controls={topicsOpen ? 'topics' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={topicsOpen ? 'true' : undefined}
                                                onClick={handleTopicsClick}
                                            >Topics
                                            </Button>
                                        </div>
                                    </div>
                                    <div>
                                        <Button
                                            sx={navButtonSx}
                                            onClick={handleAboutClick}
                                        >About Us
                                        </Button>
                                    </div>
                                </Box>
                            </Box>
                        </Toolbar>
                    </Container>
                </AppBar>
            </Box>
            <NavBar drawerMenu={drawerMenu} setDrawerMenu={setDrawerMenu} categories={categories} />

            <Menu
                id="news-and-views"
                anchorEl={newsMenu}
                open={newsOpen}
                onClose={() => { setNewsMenu(null) }}
                MenuListProps={{
                    'aria-labelledby': 'news-and-views',
                }}
            >
                {categories && categories.map((cat, index) => (['Kerala', 'National', 'International', 'Obituary', 'Article & Editorial'].includes(cat?.categoryName) &&
                    <MenuItem key={index} onClick={() => { setNewsMenu(null); navigateNewsListOfCategory(cat) }}>{cat?.categoryName}</MenuItem>
                ))}
            </Menu>

            <Menu
                id="matrimony"
                anchorEl={matrimonyMenu}
                open={matrimonyOpen}
                onClose={() => { setMatrimonyMenu(null); }}
                MenuListProps={{
                    'aria-labelledby': 'matrimony',
                }}
            >
                <MenuItem onClick={() => { setMatrimonyMenu(null); navigateMatrimonyWithType("all") }}>All</MenuItem>
                <MenuItem onClick={() => { setMatrimonyMenu(null); navigateMatrimonyWithType("bride") }}>Wanted Brides</MenuItem>
                <MenuItem onClick={() => { setMatrimonyMenu(null); navigateMatrimonyWithType("groom") }}>Wanted Grooms</MenuItem>
            </Menu>

            <Menu
                id="classifieds"
                anchorEl={productsMenu}
                open={productsOpen}
                onClose={() => { setProductsMenu(null) }}
                MenuListProps={{
                    'aria-labelledby': 'classifieds',
                }}
            >
                {categories && categories.map((cat, index) => (['Buy & Sell', 'Rentals', 'Real Estate', 'Vehicles'].includes(cat?.categoryName) &&
                    <MenuItem key={index} onClick={() => { setProductsMenu(null); navigateNewsListOfCategory(cat) }}>{cat?.categoryName}</MenuItem>
                ))}
            </Menu>

            <Menu
                id="topics"
                anchorEl={topicsMenu}
                open={topicsOpen}
                onClose={() => { setTopicsMenu(null) }}
                MenuListProps={{
                    'aria-labelledby': 'topics',
                }}
            >
                {categories && categories.map((cat, index) => (['Kidz', 'Youth', 'Women', 'Success Stories'].includes(cat?.categoryName) &&
                    <MenuItem key={index} onClick={() => { setTopicsMenu(null); navigateNewsListOfCategory(cat) }}>{cat?.categoryName}</MenuItem>
                ))}
            </Menu>
        </Box>
    )
}

export default TabNavigation;